import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { FaHome, FaUserShield, FaPiggyBank, FaDatabase, FaTasks, FaFileInvoice, FaRegHandshake, FaBars, FaChevronLeft, FaCalendarDay, FaUtensils, FaDumbbell, FaBolt } from "react-icons/fa";
import { MdOutlineTimer } from "react-icons/md";
import { GrTransaction, GrTemplate } from "react-icons/gr";
import { FaChartLine } from "react-icons/fa6";
import { CiBoxList } from "react-icons/ci";

const CustomSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ display: "flex", borderRight: "1px solid #42bdff" }}>
      <Sidebar
        collapsed={collapsed}
        className="sidebar"
        backgroundColor="#1b1b1b"
        style={{ height: "100vh", transition: "width 0.3s" }}
      >
        <Menu
          className="menu"
          menuItemStyles={{
            button: ({ level, active, disabled }) => {
              if (level === 0)
                return {
                  color: disabled ? "#black" : "#white",
                  backgroundColor: active ? "#eecef9" : undefined,
                };
            },
          }}
        >
          <MenuItem onClick={() => setCollapsed(!collapsed)} style={{ textAlign: "center" }}>
            {collapsed ? <FaBars className="ath-side-icon" /> : <FaChevronLeft className="ath-side-icon" />}
          </MenuItem>

          <Link to="/">
            <MenuItem> <FaHome className="ath-side-icon" /> Home </MenuItem>
          </Link>

          <SubMenu label={<><FaUserShield className="ath-side-icon" /> Administration</>}>
            <Link to="/tasks"><MenuItem> <FaTasks className="ath-side-icon" /> Tasks </MenuItem></Link>
            <Link to="/time-tracking"><MenuItem> <MdOutlineTimer className="ath-side-icon" /> Time Tracking </MenuItem></Link>
          </SubMenu>

          <SubMenu label={<><FaBolt className="ath-side-icon" /> Core</>}>
            <Link to="/day-builder"><MenuItem> <FaCalendarDay className="ath-side-icon" /> Day Builder </MenuItem></Link>
            <Link to="/nutrition"><MenuItem> <FaUtensils className="ath-side-icon" /> Nutrition </MenuItem></Link>
            <Link to="/workout"><MenuItem> <FaDumbbell className="ath-side-icon" /> Workout </MenuItem></Link>
          </SubMenu>

          <SubMenu label={<><FaPiggyBank className="ath-side-icon" /> Financial</>}>
            <Link to="/invoices"><MenuItem> <FaFileInvoice className="ath-side-icon" /> Invoices </MenuItem></Link>
            <Link to="/transactions"><MenuItem> <GrTransaction className="ath-side-icon" /> Transactions </MenuItem></Link>
            <Link to="/wishlist"> <MenuItem> <CiBoxList className="ath-side-icon" /> Wishlist </MenuItem></Link>
          </SubMenu>

          <SubMenu label={<><FaDatabase className="ath-side-icon" /> Data Management</>}>
            <Link to="/companies"><MenuItem> <FaRegHandshake className="ath-side-icon" /> Companies </MenuItem></Link>
            <Link to="/documents"><MenuItem> <GrTemplate className="ath-side-icon" /> Documents </MenuItem></Link>
          </SubMenu>

          <Link to="/reporting">
            <MenuItem> <FaChartLine className="ath-side-icon" /> Reporting </MenuItem>
          </Link>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default CustomSidebar;
